import base64url from 'base64url';

export const Base64Encode = data => base64url(JSON.stringify(data));

export const Base64Decode = data => JSON.parse(base64url.decode(data));



// WEBPACK FOOTER //
// ./src/utils/base64.js